import * as React from "react";
import { SnackbarContext } from "../snackbar-context";
import { Omit } from "./with-auth-context";

export interface ISnackbarContextProps {
    showSnackbarMessage: (message: string) => void;
}

export const withSnackbar = <P extends object>(Component: React.ComponentType<P & ISnackbarContextProps>) =>
    class WithAuthContext extends React.Component<Omit<P & ISnackbarContextProps, keyof ISnackbarContextProps>> {
        render(): JSX.Element {
            return <SnackbarContext.Consumer>
                {({ methods }) => (
                    <Component {...this.props as any} showSnackbarMessage={methods.showMessage} />
                )}
            </SnackbarContext.Consumer>;
        }
    };



// WEBPACK FOOTER //
// ./src/components/with-snackbar.tsx